import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';

export default function Navbar() {
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close mobile menu on route change
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const handleSignOut = async () => {
    await signOut(getAuth());
    window.location.href = '/';
  };

  return (
    <nav className={`nb-nav ${scrolled ? 'nb-nav--scrolled' : ''}`}>
      {/* brand */}
      <Link to="/users" className="nb-brand">
        <span className="nb-brand__icon">⬡</span>
        Look4Partner
      </Link>

      {/* desktop links */}
      <div className={`nb-links ${menuOpen ? 'nb-links--open' : ''}`}>
        <Link to="/users"      className={`nb-link ${isActive('/users')      ? 'nb-link--active' : ''}`}>Browse</Link>
        <Link to="/likes"      className={`nb-link ${isActive('/likes')      ? 'nb-link--active' : ''}`}>Likes</Link>
        <Link to="/matches"    className={`nb-link ${isActive('/matches')    ? 'nb-link--active' : ''}`}>Matches</Link>
        <Link to="/my-account" className={`nb-link nb-link--account ${isActive('/my-account') ? 'nb-link--active' : ''}`}>My Account</Link>
        <button className="nb-signout" onClick={handleSignOut}>Sign out</button>
      </div>

      {/* hamburger */}
      <button
        className={`nb-burger ${menuOpen ? 'nb-burger--open' : ''}`}
        onClick={() => setMenuOpen(m => !m)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}